import { SVGFC } from '@repo/toolkit/types'

const UnpublishIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4708 3.91504H12.6957C15.3804 3.91504 16.7244 3.91504 17.6566 4.55344C17.9234 4.73584 18.1606 4.95344 18.3607 5.19744C19.0591 6.05024 19.0591 7.27744 19.0591 9.73344V11.7694C19.0591 14.1398 19.0591 15.3254 18.6728 16.2718C18.0519 17.7942 16.7392 18.9942 15.074 19.5622C14.0388 19.915 12.7434 19.915 10.1493 19.915C8.66861 19.915 7.92743 19.915 7.33614 19.7134C6.38496 19.3886 5.63473 18.703 5.27979 17.8334C5.05908 17.2926 5.05908 16.615 5.05908 15.2606V11.915"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0588 11.915C19.0588 12.6222 18.7696 13.3004 18.2549 13.8005C17.7401 14.3005 17.0419 14.5814 16.314 14.5814C15.7655 14.5814 15.119 14.4886 14.5862 14.627C14.3535 14.6878 14.1413 14.807 13.9709 14.9725C13.8005 15.138 13.6779 15.3442 13.6153 15.5702C13.4728 16.0878 13.5683 16.7158 13.5683 17.2486C13.5683 17.5988 13.4973 17.9455 13.3594 18.269C13.2214 18.5925 13.0193 18.8865 12.7644 19.1341C12.5095 19.3817 12.2069 19.5781 11.8739 19.7121C11.5409 19.8461 11.184 19.915 10.8235 19.915M5.88232 5.91504C6.2875 5.51024 7.36468 3.91504 7.94115 3.91504M7.94115 3.91504C8.51762 3.91504 9.5948 5.51024 9.99997 5.91504M7.94115 3.91504V10.315"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.94092 3.74268L18.8353 20.257"
        stroke={color}
        strokeWidth="1.2619"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default UnpublishIcon
